module.exports = __webpack_public_path__ + "img/thumb_2021-07.56e19006.jpg";